export default __webpack_public_path__ + "static/media/MXChecks.d728d0af.svg";